import React, { useEffect, useMemo, useState } from 'react'
import { Button, Form } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { useLocation } from 'react-router';
import moment from 'moment';

import { Input, RenderIf } from 'components/components';
import {
  DRAWERS,
  identity,
  isEitherAdmin,
  requiredValidation,
} from 'utils';
import { IAUploadFormProps } from 'types/technicalLicenses';
import { UpdateCreateIncentiveAgreementType } from 'packages/technical_holder_repository';
import { formatDashYMD, formatSlashMDY } from '../../../utils/constants/formatters';
import { getTechnicalLicenseFile } from '../../utils';

import '../IncentiveAgreementDetailsDrawer';

const { useForm } = Form;

const IAUploadForm = (props: IAUploadFormProps) => {
  const { incentiveAgreement, technicalLicenseID, userType } = props;
  const [file, setFile] = useState<Blob | string>('');
  const [form] = useForm();
  const location = useLocation();

  useEffect(() => {
    if (isEitherAdmin(userType)) {
      setFile(incentiveAgreement.file);
    }
  }, [incentiveAgreement.file]);

  const isApprovedIncentiveAgreement = useMemo(() => location.pathname.includes('/cohorts/details') && isEitherAdmin(userType), [location]);

  const onSubmit = (formData: UpdateCreateIncentiveAgreementType) => {
    const data: UpdateCreateIncentiveAgreementType = { technicalLicenseID };
    if (identity.isZero(incentiveAgreement.id)) {
      data.file = file;
      props.actions.createIncentiveAgreement({ data });
    } else {
      if (isEitherAdmin(userType)) {
        data.startDate = formData.startDate ? moment(formData.startDate).utc().format(formatDashYMD) : '';
        data.endDate = formData.endDate ? moment(formData.endDate).utc().format(formatDashYMD) : '';
        data.walletAmount = formData.walletAmount || 0;
      } else {
        data.file = file;
      }
      props.actions.updateIncentiveAgreement({ data, id: incentiveAgreement.id });
    }

    if (isApprovedIncentiveAgreement) {
      props.actions.setDrawerBody({ drawerBody: DRAWERS.incentiveAgreement });
    }
  }

  const beforeUpload = (uploadFile: RcFile) => {
    setFile(uploadFile as Blob);
    form.setFieldValue('file', uploadFile as Blob);
    return false;
  }

  return (
    <div className="incentive-agreement-upload-drawer">
      <Form form={form} onFinish={onSubmit}>
        <RenderIf condition={isApprovedIncentiveAgreement}>
          <Input label="Start Date" name="startDate" required requiredMark rules={[requiredValidation]}>
            <Input.DatePicker placeholder="Start Date" format={formatSlashMDY} />
          </Input>
          <Input label="End Date" name="endDate" required requiredMark rules={[requiredValidation]}>
            <Input.DatePicker placeholder="End Date" format={formatSlashMDY} />
          </Input>
          <Input label="Wallet Amount" name="walletAmount" required requiredMark rules={[requiredValidation]}>
            <Input.InputNumber placeholder="wallet amount in AED" />
          </Input>
        </RenderIf>
        <RenderIf condition={!isApprovedIncentiveAgreement}>
          <p className="message">Please upload signed incentive agreement</p>
          <Input label="Incentive Agreement File" name="file" required requiredMark rules={[requiredValidation]}>
            <Input.DraggerUpload
              accept=".pdf"
              beforeUpload={beforeUpload}
              previewType="image"
              isRoundableButton
              defaultFileList={isEitherAdmin(userType) ? [...getTechnicalLicenseFile(incentiveAgreement?.file)] : []}
            />
          </Input>
        </RenderIf>
        <div className="submit-button">
          <Button type="primary" htmlType="submit" className="primary-button">Submit</Button>
        </div>
      </Form>
    </div>
  );
}

export default IAUploadForm;
